import { Card, Statistic, Tag, Tooltip, Typography } from 'antd';
import type { ReactNode } from 'react';
import { formatMoney } from '../api/client';
import { platformColor, semantic, type Semantic } from '../theme';

/** Ô KPI có viền màu theo ý nghĩa (doanh thu xanh dương, phí đỏ, khớp xanh lá…). */
export function Kpi({ k, title, value, suffix, hint }: { k: Semantic; title: string; value: ReactNode; suffix?: string; hint?: ReactNode }) {
  return (
    <Card size="small" className="kpi" style={{ ['--c' as string]: semantic[k].c, ['--cs' as string]: semantic[k].cs, height: '100%' }}>
      <Statistic title={title} value={value as string} {...(suffix ? { suffix } : {})} />
      {hint && (
        <Typography.Text type="secondary" style={{ fontSize: 12 }}>
          {hint}
        </Typography.Text>
      )}
    </Card>
  );
}

export function Money({ v, strong }: { v: string; strong?: boolean }) {
  const neg = v.startsWith('-');
  return (
    <span className={`money${neg ? ' neg' : ''}`} style={strong ? { fontWeight: 600 } : undefined}>
      {formatMoney(v)}
    </span>
  );
}

export function PlatformTag({ p }: { p: 'shopee' | 'tiktok' | null }) {
  if (!p) return null;
  return (
    <Tag bordered={false} style={{ color: platformColor[p].c, background: platformColor[p].cs, marginInlineEnd: 0 }}>
      {p === 'shopee' ? 'Shopee' : 'TikTok'}
    </Tag>
  );
}

export const periodLabel = (p: string) => {
  const q = /^(\d{4})-Q([1-4])$/.exec(p);
  return q ? `Quý ${q[2]}/${q[1]}` : `Tháng ${p.slice(5)}/${p.slice(0, 4)}`;
};

export const viDate = (d: string | null | undefined) => (d ? d.split('-').reverse().join('/') : '—');

/** Biểu đồ cột theo ngày (SVG thuần, không cần thư viện biểu đồ). */
export function DailyBars({ data, color }: { data: { date: string; value: number; label: string }[]; color: string }) {
  const max = Math.max(1, ...data.map((d) => d.value));
  const w = 100 / Math.max(1, data.length);
  return (
    <div className="daily-bars" role="img" aria-label="Biểu đồ số đơn theo ngày">
      <svg viewBox="0 0 100 40" preserveAspectRatio="none" width="100%" height="140">
        {data.map((d, i) => {
          const h = (d.value / max) * 38;
          return (
            <rect key={d.date} x={i * w + w * 0.15} y={40 - h} width={w * 0.7} height={h} fill={color} rx={0.4}>
              <title>{d.label}</title>
            </rect>
          );
        })}
      </svg>
      <div className="daily-bars-axis">
        <span>{viDate(data[0]?.date)}</span>
        <span>{viDate(data.at(-1)?.date)}</span>
      </div>
    </div>
  );
}

export function HelpTip({ text }: { text: string }) {
  return (
    <Tooltip title={text}>
      <Typography.Text type="secondary" style={{ cursor: 'help', fontSize: 12 }}>
        ⓘ
      </Typography.Text>
    </Tooltip>
  );
}
